import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import useAppStore from '../../store/useAppStore';
import SortableTableRow from '../SortableTableRow';
import DeviceSelect from './DeviceSelect';
import StationSelect from './StationSelect';
import IndexField from 'components/IndexField';
import { useShallow } from 'zustand/react/shallow';
const RenderScriptValue = ({ index, valueKey }) => {
  const value = useAppStore((state) => state.scripts[index][valueKey]);
  return <TableCell>{value}</TableCell>;
};
const EditSegList = () => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );
  const readOnly = useAppStore((state) => state.selectedProject.readOnly);
  const scriptKeys = useAppStore((state) => state.scriptKeys);
  const scriptsIds = useAppStore(
    useShallow((state) => state.scripts.map((value) => value.id)),
  );
  const addScript = useAppStore((state) => state.addScript);
  const deleteScript = useAppStore((state) => state.deleteScript);
  const reorderScripts = useAppStore((state) => state.reorderScripts);
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = scriptsIds.findIndex((id) => id === active.id);
      const newIndex = scriptsIds.findIndex((id) => id === over.id);
      reorderScripts(oldIndex, newIndex);
    }
  };
  return (
    <>
      <div className="flex justify-between">
        <Typography variant="h6">區段流程列表</Typography>
        {readOnly === false && (
          <div className="flex gap-2 flex-wrap justify-end">
            <Button
              startIcon={<Add />}
              variant="contained"
              onClick={() => {
                addScript(0);
              }}
            >
              新增區段腳本
            </Button>
          </div>
        )}
      </div>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
        modifiers={[restrictToVerticalAxis]}
      >
        <Table>
          <TableHead>
            <TableRow>
              {scriptKeys.map((key) => (
                <TableCell key={key}>{key}</TableCell>
              ))}
              {readOnly === false && <TableCell>刪除</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            <SortableContext
              items={scriptsIds}
              strategy={verticalListSortingStrategy}
            >
              {scriptsIds.map((id, index) => (
                <SortableTableRow key={id} id={id}>
                  <TableCell sx={{ p: 1 }}>
                    <IndexField
                      sx={{ minWidth: 150 }}
                      size="small"
                      type="scripts"
                      valueKey="區段腳本名稱"
                      index={index}
                      placeholder="輸入腳本名稱"
                    />
                  </TableCell>
                  <StationSelect
                    index={index}
                    valueKey="起始工站"
                    placeholder="選擇起始工站"
                  />
                  <DeviceSelect index={index} />
                  <StationSelect
                    index={index}
                    valueKey="目標工站"
                    placeholder="選擇目標工站"
                  />
                  {scriptKeys.map((key) => {
                    switch (key) {
                      case '區段腳本名稱':
                      case '起始工站':
                      case '目標工站':
                      case '移動設備':
                        return null;
                      default:
                        return (
                          <RenderScriptValue
                            key={key}
                            index={index}
                            valueKey={key}
                          />
                        );
                    }
                  })}
                  {readOnly === false && (
                    <TableCell sx={{ p: 1 }}>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => addScript(index + 1)}
                          title="在此行後插入"
                        >
                          <Add fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => deleteScript(id)}
                          title="刪除此行"
                        >
                          <Delete fontSize="small" />
                        </IconButton>
                      </Box>
                    </TableCell>
                  )}
                </SortableTableRow>
              ))}
            </SortableContext>
          </TableBody>
        </Table>
      </DndContext>
    </>
  );
};
export default EditSegList;
